import classNames from "classnames";
import React, { ReactNode } from "react";
import styles from "./ExternalDocument.module.scss";

type ExternalDocumentProps = {
  className?: string;
  children?: ReactNode;
};

export const ExternalDocument: React.FunctionComponent<ExternalDocumentProps> = ({ className, children }) => {
  return <div className={classNames(styles.externalDocument, className)}>{children}</div>;
};
